import { useCookie } from 'next-cookie'
import React, { useState, useEffect } from 'react'
import { Provider } from 'jotai'
import _ from 'lodash'
// import axios from 'axios'
import Head from 'next/head'
import { AnimatePresence } from 'framer-motion'
import { useRouter } from 'next/router'
// import faunadb from 'faunadb'
// const q = faunadb.query
// const client = new faunadb.Client({
//   timeout: 3000,
//   secret: process.env.FAUNADB_SERVER_KEY,
// })

import Cookies from 'js-cookie'

import {
  manifestStatic,
  pageContentStatic,
  manifestDesign,
  pageContentDesign,
  manifestBlocks,
  pageContentBlocks,
  isLoggedIn,
  userEmail,
  userContents,
  isSharedContent,
} from '@/utils/op-types/store'

import { connectToDatabase } from '@/utils/mongo'

import OnepagerTypesManifests from '@/utils/op-types/Types'
import AutoSave from '@/components/optypes/AutoSave'

import ClientActions from '@/components/optypes/ClientActions'

import HeaderWrapper from '@/components/optypes/frontend/HeaderWrapper'
import CollectionHeader from '@/components/optypes/frontend/CollectionHeader'
import ShareHeader from '@/components/optypes/frontend/ShareHeader'
import PublicHelloBar from '@/components/onepager/PublicHelloBar'
import SignUpModal from '@/components/optypes/frontend/SignUpModal'
import ShareModal from '@/components/optypes/frontend/ShareModal'

// Renderer components
import BookReview from '@/components/optypes/frontend/BookReview/BookReview'
import LinkTree from '@/components/optypes/frontend/LinkTree/LinkTree'
import PHChat from '@/components/optypes/frontend/PHChat/PHChat'

// production components
import SideScroller from '@/components/optypes/frontend/SideScroller/SideScroller'
import CenterScroller from '@/components/optypes/frontend/CenterScroller/CenterScroller'
import CardScroller from '@/components/optypes/frontend/CardScroller/CardScroller'
import SimpleGridScroller from '@/components/optypes/frontend/SimpleGridScroller/SimpleGridScroller'
import StickyScroller from '@/components/optypes/frontend/StickyScroller/StickyScroller'

/* BLOCK_INJECT_IMPORT */
import AskCampaign from '@/components/optypes/frontend/AskCampaign/Main'
import StickyPage from '@/components/optypes/frontend/StickyPage/Main'
import SimpleChecklist from '@/components/optypes/frontend/SimpleChecklist/Main'
import SimpleKanban from '@/components/optypes/frontend/SimpleKanban/Main'
import HubPage from '@/components/optypes/frontend/HubPage/Main'
import ThreeColumnResources from '@/components/optypes/frontend/ThreeColumnResources/Main'
import SimpleResourceList from '@/components/optypes/frontend/SimpleResourceList/Main'

// type components
const Components = {
  // dev testing
  bookreview: BookReview,
  linktree: LinkTree,
  phchat: PHChat,

  /* BLOCK_INJECT_COMPONENT */
  askcampaign: AskCampaign,
  stickypage: StickyPage,
  simplechecklist: SimpleChecklist,
  simplekanban: SimpleKanban,
  hubpage: HubPage,
  threecolumnresources: ThreeColumnResources,
  simpleresourcelist: SimpleResourceList,
  sidescroller: SideScroller,
  centerscroller: CenterScroller,
  cardscroller: CardScroller,
  simplegridscroller: SimpleGridScroller,
  stickyscroller: StickyScroller,
}

const RenderOnepagerPage = ({
  onepagerId,
  onepagerContent,
  onepagerType,
  typeManifest,
  userContentsSource,
  getUserEmail,
  checkLoggedIn,
  userSavedContents,
  shareContent,
  isAutoSignUp,
  customCSS,
}) => {
  const router = useRouter()

  const [helloBar, setHelloBar] = useState(
    onepagerContent.collection?.header_cta_link,
  )

  useEffect(async () => {
    // if (analytics) {
    //   analytics.track({
    //     event: 'onepagerPageView',
    //     properties: {
    //       type: 'new-type',
    //     },
    //   })
    // }
    // if (isAutoSignUp) {
    //   var newurl =
    //     window.location.protocol +
    //     '//' +
    //     window.location.host +
    //     window.location.pathname
    //   window.history.pushState({ path: newurl }, '', newurl)
    // }
    // try {
    //   if (!router.query.preview) {
    //     await axios.post('/api/wvtr-type', {
    //       id: onepagerId,
    //     })
    //   }
    // } catch (err) {
    //   // don't catch error
    // }
  }, [])

  return (
    <Provider
      initialValues={[
        [isLoggedIn, checkLoggedIn],
        [userEmail, getUserEmail],
        [userContents, userSavedContents],
        [isSharedContent, shareContent],
        [manifestStatic, typeManifest.static],
        [manifestDesign, typeManifest.design],
        [manifestBlocks, typeManifest.blocks],
        // [pageContentStatic, JSON.parse(onepagerContent.static)],
        // [pageContentDesign, JSON.parse(onepagerContent.design)],
        // [pageContentBlocks, JSON.parse(onepagerContent.blocks)],
        [pageContentStatic, onepagerContent.static],
        [pageContentDesign, onepagerContent.design],
        [pageContentBlocks, onepagerContent.blocks],
      ]}
    >
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 999999999,
        }}
        className="bg-black flex items-center space-x-4 justify-between px-6  tracking-widest sticky top-0 text-white h-10 p-2 text-center"
      >
        <div className="font-bold">
          Read Only Mode -- Checkout{' '}
          <a
            href="https://contentblocks.com"
            target="_blank"
            style={{
              textUnderlineOffset: 4,
              textDecorationThickness: 2,
              textDecorationColor: '#FEC802',
            }}
            className="underline	"
          >
            ContentBlocks.com
          </a>
        </div>
        <div
          onClick={() => {
            // open input alert to get email
            let email = prompt(
              'Enter in your email that you used to sign up this page to load up personal saved content',
            )

            if (email) {
              // save email in wl-email cookie
              Cookies.set('wl-email', email)

              // reload page
              window.location.reload()
            }
          }}
          className="font-bold cursor-pointer opacity-70 hover:opacity-100"
        >
          Load Personal Content
        </div>
      </div>

      <div>
        <Head>
          <title>{onepagerContent.title} - onepager.io</title>
          {customCSS && <style>{customCSS}</style>}
        </Head>

        {/* auto saver  */}
        {/* <AutoSave id={onepagerId} /> */}

        {/* client actions */}
        <ClientActions id={onepagerId} type={onepagerType} />

        {/* header wrapper - for getting size */}
        {/* <HeaderWrapper>
          <ShareHeader />

          {!router.query.preview && (
            <CollectionHeader onepager={onepagerContent} />
          )}


          <AnimatePresence initial={false} exitBeforeEnter>
            {helloBar && (
              <PublicHelloBar
                collection={onepagerContent.collection}
                hideBar={() => {
                  setHelloBar(false)
                }}
              />
            )}
          </AnimatePresence>
        </HeaderWrapper> */}

        {/* render front ends */}
        {React.createElement(Components[onepagerType], {
          id: onepagerId,
          onepager: onepagerContent,
        })}

        {/* sign up modal */}
        {/* <SignUpModal id={onepagerId} onepager={onepagerContent} /> */}

        {/* share modal */}
        {/* <ShareModal id={onepagerId} onepager={onepagerContent} /> */}
      </div>
    </Provider>
  )
}

export default RenderOnepagerPage

// export async function getStaticPaths() {
//   return { paths: [], fallback: 'blocking' }
// }

export async function getServerSideProps(context) {
  // let reqHost = context.req.headers.host
  // reqHost = reqHost.split('.')

  // console.log('CONTEXT TEST')
  // console.log(context)

  const { db } = await connectToDatabase()

  let isPreview = false
  let previewData = {}

  let isShareContent = false

  let isAutoSignUp = false

  // const nxtCookie = useCookie(context)
  let isSignedUp = false
  // let userEmail = nxtCookie.get('wl-email') ? nxtCookie.get('wl-email') : ''
  let userEmail = ''

  let getURL = context.params.url
  getURL = getURL.split('-')
  getURL = getURL.pop()

  console.log(getURL)

  // Check Template Page
  const getTemplatePage = await db.collection('Pages').findOne({
    _id: getURL,
  })

  // console.log(getTemplatePage)

  const getPageTypes = await db.collection('PageTypes').find({}).toArray()

  const getPageType = getPageTypes.find(
    pageType => pageType._id == getTemplatePage.type,
  )

  // const getPageContentsFQL = await fetch('https://db.fauna.com/query/1', {
  //   method: 'POST',
  //   headers: {
  //     Authorization: 'Bearer ' + process.env.FAUNADB_SERVER_KEY,
  //   },
  //   body: JSON.stringify({
  //     query: `
  //        OnepagerTypePageContents.byId("${getURL}") {
  //         _id: .id,
  //         title,
  //         static,
  //         blocks,
  //         design,
  //         starter_usercontents,
  //         customCSS,
  //         type {
  //           _id: .id,
  //           file
  //         },
  //         integration {
  //           _id: .id,
  //           service
  //         },
  //         collection{
  //           _id: .id,
  //           root,
  //           title,
  //           brand,
  //           logo,
  //           banner_bg_color,
  //           banner_text_color,
  //           header_cta_link,
  //           header_bg_color,
  //           header_cta_text,
  //           header_text_color,
  //           header_cta_button_text,
  //         }
  //        }
  //     `,
  //   }),
  // })
  //   .then(res => res.json())
  //   .then(ret => ret.data)

  // return Onepager Manifest
  const manifestObj = OnepagerTypesManifests[getPageType.file]

  // create blank user contents
  let userContentsSource = {}
  // let blocks = JSON.parse(getPageContentsFQL.blocks)
  let blocks = []

  try {
    blocks = JSON.parse(getTemplatePage.blocks)
  } catch (e) {
    blocks = getTemplatePage.blocks
  }

  // check if page content has user content
  if (getTemplatePage.starter_usercontents) {
    // page content has starter_content
    userContentsSource = JSON.parse(getTemplatePage.starter_usercontents)
    // userContentsSource = getPageContentsFQL.starter_usercontents
  } else {
    // no user contents - create based on manifest
    blocks.forEach(block => {
      if (manifestObj.blocks[block.block].settings.type == 'editable') {
        // merge source with page contents

        userContentsSource[block.id] = _.merge(
          block.usercontent,
          manifestObj.blocks[block.block].usercontent,
        )
      }
    })
  }

  // check if user is signed up & get content
  let getUserContents = userContentsSource

  let staticContent = {}
  let design = {}

  try {
    staticContent = JSON.parse(getTemplatePage.static)
    design = JSON.parse(getTemplatePage.design)
  } catch (e) {
    staticContent = getTemplatePage.static
    design = getTemplatePage.design
  }

  let onepagerContent = {
    ...getTemplatePage,
    blocks: blocks,
    starter_usercontents: userContentsSource,
    static: staticContent,
    design,
  }

  return {
    props: {
      onepagerId: getURL,
      onepagerContent: isPreview ? previewData : onepagerContent,
      onepagerType: getPageType.file,
      typeManifest: manifestObj,
      userContentsSource: userContentsSource,
      getUserEmail: userEmail,
      checkLoggedIn: isSignedUp,
      userSavedContents: getUserContents,
      shareContent: isShareContent,
      isAutoSignUp: isAutoSignUp,
      customCSS: getTemplatePage?.customCSS ?? '',
    },
  }
}
